import { render, staticRenderFns } from "./ConsumeList.vue?vue&type=template&id=a510edb2&scoped=true&"
import script from "./ConsumeList.vue?vue&type=script&lang=js&"
export * from "./ConsumeList.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeList.vue?vue&type=style&index=0&id=a510edb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510edb2",
  null
  
)

export default component.exports